import { useDataValue, useDataFormat } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

export default function useDataConfiguration(props) {
  let parent_company_id = useDataValue({
    context: 'tab',
    path: 'selected.parent_company_id',
    viewPath: props.viewPath,
  })
  let search_term = useDataValue({
    context: 'patient_select',
    path: 'search_term',
    viewPath: props.viewPath,
  })
  let is_patient = useDataFormat({
    context: 'referral',
    path: 'template.id',
    viewPath: props.viewPath,
    format: value => value === 'Patient',
  })

  let search_term_stable = useStableValue(wrapSearchTerm(search_term))

  return {
    variables: {
      search_term: search_term_stable || '',
      parent_company_id,
      is_patient,
    },
    pause: search_term_stable.length - wrapSearchTerm('').length < 3,
  }
}

function wrapSearchTerm(search_term) {
  return `%${search_term}%`
}
